import { useWeddingWebsiteQuery } from '../../../generated/graphql';
import ShareButton from '../../PreviewPage/EditInPreview/ShareButton';
import React from 'react';
import PublishWebsiteButton from '../PublishWebsiteButton/PublishWebsiteButton';
import PublishWebsiteModal from '../PublishWebsiteModal/PublishWebsiteModal';

export interface ShareOrPublishButtonProps {
  trackSource: string;
  buttonSize?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  setShowPublishedIndexBanner?: (show: boolean) => void;
}

const ShareOrPublishButton = ({
  trackSource,
  buttonSize = 'lg',
  fullWidth = false,
  setShowPublishedIndexBanner,
}: ShareOrPublishButtonProps) => {
  const { data: wwsData } = useWeddingWebsiteQuery();
  const isUserEmailVerified = wwsData?.member?.isEmailVerified || false;
  const isWebsitePublished = wwsData?.weddingWebsite?.state === 'published';

  const vanityRoot = wwsData?.weddingWebsite?.vanityRoot;
  const slug = wwsData?.weddingWebsite?.vanityUrl || wwsData?.weddingWebsite?.slug;
  const displayUrl = vanityRoot && slug ? `${vanityRoot}${slug}` : '';

  // If the website is published, we don't need the user to verify their email.
  const shouldRenderPublishButton = isWebsitePublished ? false : !isUserEmailVerified || !isWebsitePublished;

  const [shouldRenderPublishModal, setShouldRenderPublishModal] = React.useState(false);

  return (
    <>
      {shouldRenderPublishButton ? (
        <PublishWebsiteButton
          size={buttonSize}
          fullWidth={fullWidth}
          isUserEmailVerified={isUserEmailVerified}
          isWebsitePublished={isWebsitePublished}
          trackSource={trackSource}
          onClick={() => setShouldRenderPublishModal(true)}
          setShowPublishedIndexBanner={setShowPublishedIndexBanner}
        />
      ) : (
        <ShareButton trackSource={trackSource} url={displayUrl} size={buttonSize} />
      )}
      {shouldRenderPublishModal && <PublishWebsiteModal onClose={() => setShouldRenderPublishModal(false)} />}
    </>
  );
};

export default ShareOrPublishButton;
